<template>
  <div class="car-feature">
    <div class="row">
      <div class="col-sm-6">
        <h4>{{ carFeature.name }}</h4>
        <span class="fa fa-2x" :class="[
          carFeature.icon,
          {
            'fab': carFeature.icon === 'fa-bluetooth',
            'fa': carFeature.icon !== 'fa-bluetooth'
          }
        ]"></span>
      </div>
      <div class="col-sm-6">
        <h4>Cars</h4>
        <template v-for="car in carFeature.Cars">
          <p>
            <router-link :to="{ path: '/fleet/vehicles/' + car.uuid }">
              {{ car.dropdownLabel }}
            </router-link>
          </p>
        </template>
      </div>
    </div>
    <div class="toolbar text-right">
      <router-link class="btn btn-default"
            :to="{ path: `/fleet/vehicles/features/edit/${carFeature.uuid}` }">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarFeature',
  props: {
    object: {
      type: Object
    }
  },
  data () {
    return {
      carFeature: {
      }
    }
  },
  mounted () {
    this.carFeature = this.object
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/CarFeature.vue